import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
 avatarWrapper: {
    '& .MuiAvatar-img': {
      height: '18px',
      width: '18px'
    },
    '& .MuiAvatar-root': {
      height: '18px',
      width: '18px',
      marginLeft: '6px'
    }
  }
});
